module.exports = __webpack_public_path__ + "static/media/Neville Longbottom 2.936096cd.jpg";